import { getById, getAll } from "@/utilities/querySelector";

document.addEventListener('DOMContentLoaded', () => {
    const headerHeight = getById('site-header').offsetHeight;
    let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const isScrollingDown = (window.pageYOffset || document.documentElement.scrollTop) > lastScrollTop;
            lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (entry.isIntersecting) {
                entry.target.setAttribute('data-in-view', 'true');
                if (entry.target.hasAttribute('data-in-view-scrolldown')) {
                    entry.target.setAttribute('data-in-view-scrolldown-triggered', 'true');
                }
            } else {
                if (entry.target.hasAttribute('data-in-view-scrolldown')) {
                    if (!isScrollingDown && entry.target.getAttribute('data-in-view-scrolldown-triggered') !== 'true') {
                        entry.target.setAttribute('data-in-view', 'false');
                    }
                } else {
                    entry.target.setAttribute('data-in-view', 'false');
                }
            }
        });
    }, {
        threshold: [0, 0.25, 0.5, 0.75, 1], // Adjusted threshold values
        rootMargin: `0px 0px -${headerHeight}px 0px`
        // threshold: [0.75, 1],
        // rootMargin: `-${headerHeight}px 0px 0px 0px`
    });

    getAll('[data-in-view]').forEach((element) => {
        observer.observe(element);
    });
});


export const freezeInViewObserver = (element) => {
    if (!element) return;

    element.setAttribute('data-in-view-active', 'true');
    element.setAttribute('data-in-view-scrolldown-triggered', 'true');
}
